export default "__VITE_ASSET__BVrRaVV2__"